const tabButtons = document.querySelectorAll(
	'.block-tab-standard-tab > .wp-block-button .wp-block-button__link'
);

const tabBlocks = document.querySelectorAll('.block-tab-standard');

const toggleTab = (e) => {
	e.preventDefault();

	const tabBlock = e.currentTarget.closest('.block-tab-standard');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tab-standard-tab > .wp-block-button.active'
		);

		if (activeTabs.length) {
			activeTabs.forEach((activeTab) => {
				if (activeTab !== e.currentTarget.parentElement) {
					activeTab.classList.remove('active');
				}
			});
		}

		e.currentTarget.parentElement.classList.add('active');

		const selectElement = tabBlock.querySelector(
			'.block-tab-standard__mobile-select'
		);
		const tab = e.currentTarget.closest('.block-tab-standard-tab');

		if (tab && tab.hasAttribute('data-index') && selectElement) {
			selectElement.value = tab.getAttribute('data-index');
		}
	}
};

const mobileSelect = (e) => {
	const tabBlock = e.currentTarget.closest('.block-tab-standard');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tab-standard-tab > .wp-block-button.active'
		);
		const currentTabButton = tabBlock.querySelector(
			'.block-tab-standard-tab[data-index="' +
				e.currentTarget.value +
				'"] > .wp-block-button'
		);

		if (currentTabButton) {
			if (activeTabs.length) {
				activeTabs.forEach((activeTab) => {
					if (activeTab !== e.currentTarget.parentElement) {
						activeTab.classList.remove('active');
					}
				});
			}

			currentTabButton.classList.add('active');
		}
	}
};

if (tabButtons.length) {
	tabButtons.forEach((tabButton) => {
		tabButton.addEventListener('click', toggleTab);
	});
}

if (tabBlocks.length) {
	tabBlocks.forEach((tabBlock) => {
		const tabs = tabBlock.querySelectorAll('.block-tab-standard-tab');

		if (tabs.length) {
			const selectElement = tabBlock.querySelector(
				'.block-tab-standard__mobile-select'
			);

			if (!selectElement) {
				return;
			}

			tabs.forEach((tab, index) => {
				const tabButton = tab.querySelector(
					'.block-tab-standard-tab > .wp-block-button'
				);

				if (tabButton) {
					const option = document.createElement('option');
					option.value = index;
					option.text = tabButton.textContent;
					selectElement.appendChild(option);
					tab.setAttribute('data-index', index);

					if (index + 1 === tabs.length) {
						selectElement.addEventListener('change', mobileSelect);
						tab.parentElement.appendChild(selectElement);
					}
				}

				tabButton.classList.add('initialized');

				if (0 === index) {
					tabButton.classList.add('active');
				}
			});
		}
	});
}

document.addEventListener('DOMContentLoaded', function () {
	tabBlocks.forEach((block, blockIndex) => {
		const tabItems = block.querySelectorAll('.block-tab-standard-tab');

		const tabs = Array.from(tabItems)
			.map((tabItem, i) => {
				const button = tabItem.querySelector(
					':scope > .wp-block-button .wp-block-button__link'
				);
				const panel = tabItem.querySelector(':scope > section');
				return { tabItem, button, panel, index: i };
			})
			.filter((tab) => tab.button && tab.panel);

		const tabList = block.querySelector('.block-tab-standard__content');
		if (tabList) tabList.setAttribute('role', 'tablist');

		const select = block.querySelector(
			'.block-tab-standard__mobile-select'
		);
		const thisHeading = block.querySelector(
			'.block-tab-standard__content > .block-content h2'
		);

		if (select) select.innerHTML = '';

		if (select && thisHeading) {
			select.setAttribute('aria-label', thisHeading.textContent.trim());
		}

		tabs.forEach(({ button, panel }, index) => {
			const tabId = `tab-standard-${blockIndex}-${index}`;
			const panelId = `tabpanel-standard-${blockIndex}-${index}`;

			button.setAttribute('role', 'tab');
			button.setAttribute('id', tabId);
			button.setAttribute('aria-controls', panelId);
			button.setAttribute('tabindex', index === 0 ? '0' : '-1');
			button.setAttribute(
				'aria-selected',
				index === 0 ? 'true' : 'false'
			);

			panel.setAttribute('role', 'tabpanel');
			panel.setAttribute('id', panelId);
			panel.setAttribute('aria-labelledby', tabId);
			panel.hidden = index !== 0;

			if (select) {
				const option = document.createElement('option');
				option.value = index;
				option.textContent = button.textContent;
				select.appendChild(option);
			}

			button.addEventListener('click', () => activateTab(index));

			button.addEventListener('keydown', (e) => {
				let newIndex;
				if (e.key === 'ArrowRight')
					newIndex = (index + 1) % tabs.length;
				else if (e.key === 'ArrowLeft')
					newIndex = (index - 1 + tabs.length) % tabs.length;
				else if (e.key === 'Home') newIndex = 0;
				else if (e.key === 'End') newIndex = tabs.length - 1;
				else return;

				e.preventDefault();
				tabs[newIndex].button.focus();
				activateTab(newIndex);
			});
		});

		if (select) {
			select.addEventListener('change', (e) => {
				const newIndex = parseInt(e.target.value, 10);
				activateTab(newIndex);
			});
		}

		function activateTab(activeIndex) {
			tabs.forEach(({ button, panel }, i) => {
				const isActive = i === activeIndex;

				button.setAttribute(
					'aria-selected',
					isActive ? 'true' : 'false'
				);
				button.setAttribute('tabindex', isActive ? '0' : '-1');
				panel.hidden = !isActive;

				const buttonWrapper = button.closest('.wp-block-button');
				if (buttonWrapper) {
					buttonWrapper.classList.toggle('active', isActive);
				}

				if (select && select.value !== String(activeIndex)) {
					select.value = activeIndex;
				}
			});
		}
	});
});
